module.exports = __webpack_public_path__ + "static/book-logo-55fd33a54522f4e83409ca468e68ac0a.png";